    
        <div class="grid">
            <div class="col-8 input-field">
                <label *ngIf="!providerId" for="selectedTransaction">{{type=="COMPANY"?"Presupuesto a la compañía":"Presupuesto de operario"}}</label>
                 <label  *ngIf="providerId" for="selectedTransaction">{{type=="COMPANY"?"Solicitud de compra a la compañía":"Solicitud de compra de operario"}}</label>
                <p-dropdown [(ngModel)]="selectedTransaction" [ngModelOptions]="{standalone:true}" [options]="transactions"
                    (onChange)="loadTransactionLines()" optionLabel="customName" optionValue="id" [filter]="true" filterBy="customName"
                    appendTo="body" placeholder="{{!providerId ? 'Selecciona un presupuesto' : 'Selecciona una solicitud de compra'}}" d-form-field-error></p-dropdown>
                <p-tag *ngIf="providerId&&type=='COMPANY'&&getInfoFromSelectedTransaction().transactionTypeCode=='purchase_order'" severity="danger" value="RECUERDE: Las solicitudes de compra se pasarán a la compañía sin descuento"></p-tag>
                
            </div>
            <div class="col-4 input-field">
                <label for="capabilityId">Especialidad</label>
                <p-dropdown [options]="capabilities" [(ngModel)]="selectedCapability" showClear [filter]="true"
                    filterBy="name" placeholder="Seleccione una especialidad" optionLabel="name" optionValue="id"
                    d-form-field-error appendTo="body" (onChange)="loadTransactionLines()"></p-dropdown>
            </div>
        </div>        
        <p-table styleClass="m-1 mt-4" #grid [value]="transactionLines" [loading]="loadingTransactionLines"            
            [scrollable]="true" scrollHeight="flex"
            [(selection)]="selectedLines"
            dataKey="id" 
            >
            <ng-template pTemplate="header" let-columns>
                <tr>                    
                    <th><p-tableHeaderCheckbox *ngIf="transactionLines.length>0" /></th>       
                    <th>Especialidad</th>                                                         
                    <th>Baremo</th>                                            
                    <th style="text-align: right;">Cantidad</th>                        
                    <th style="text-align: right;">Precio unidad</th>      
                    <th style="text-align: right;">Descuento</th>                        
                    <th style="text-align: right;">Impuestos</th>                        
                    <th style="text-align: right;">Importe</th>                                            
                </tr>
            </ng-template> 
            <ng-template pTemplate="body" let-transactionLine let-i="rowIndex" let-columns="columns" let-index="rowIndex">
                <tr *ngIf="transactionLine.isGroup" [pReorderableRow]="i" [class.rowGroup]="transactionLine.isGroup">                    
                    <td *ngIf="transactionId">
                        <p-tableCheckbox [value]="transactionLine"></p-tableCheckbox>
                    </td>
                    <td [attr.colspan]="type=='Company'?9:8" class="rowGroup"><b>{{transactionLine.description}}</b></td>                    
                </tr>
                <tr *ngIf="!transactionLine.isGroup" [pReorderableRow]="i">
                    <td>
                        <p-tableCheckbox [value]="transactionLine"></p-tableCheckbox>
                    </td>
                    <td>{{transactionLine.rateLine?.capability?.name}}</td>
                    <!--<td *ngIf="transactionLine.rateLine">{{transactionLine.rateLine?.code}}<br> {{transactionLine.rateLine?.description}}  {{transactionLine.description}}</td>-->
                    <td>{{transactionLine.rateLineCode}} {{transactionLine.rateLineDescription}} {{transactionLine.description}}</td>
                    <td style="text-align: right;">{{transactionLine.quantity}}</td>
                    <td style="text-align: right;">{{transactionLine.price}}</td>
                    <td style="text-align: right;">{{'('+(transactionLine.discountPercent!=null?transactionLine.discountPercent:0)+'%) '}}{{transactionLine.discountAmount | currency: 'EUR' }}</td>                        
                    <td style="text-align: right;">{{'('+(transactionLine.taxPercent!=null?transactionLine.taxPercent:0)+'%) '}}{{transactionLine.taxAmount | currency: 'EUR' }}</td>
                    <td style="text-align: right;">{{transactionLine.subtotal | currency: 'EUR' }}</td>                    
                </tr>
            </ng-template>            
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td style="text-align: center;" colspan="9">
                        No se han encontrado líneas.
                    </td>
                </tr>
            </ng-template>
        </p-table>    
    <div class=" mt-4 flex gap-2 justify-content-end">        
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite && !transactionId" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
        <p-button label="Añadir líneas" *ngIf="allowWrite && transactionId" icon="pi pi-check" styleClass="p-ml-2" (click)="saveLinesInTransaction()"></p-button>
    </div>
<p-confirmDialog></p-confirmDialog>